import { Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation();
  const page = "not-found";
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Stack gap={3} justifyContent="center" padding="3rem">
        <Stack gap={1}>
          <Typography variant="h4" fontWeight={600}>
            {t(`${page}.header`, "Oops! We couldn’t find that page.")}
          </Typography>
          <Typography variant="h6">
            {t(
              `${page}.text`,
              "It looks like the link is broken or the page has been removed."
            )}
          </Typography>
        </Stack>
        <Button onClick={() => navigate("/auth-queue")}>
          {t(`${page}.button-text`, "Return home")}
        </Button>
      </Stack>
    </Container>
  );
};

export default NotFound;
